













import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BirthdayPicker extends Vue {
  @Prop() value!: string
  @Prop() print!: boolean

  get birthday() {
    return this.value
  }

  set birthday(value) {
    this.$emit('update:value', value)
  }
}
